import { LOCATIONS } from "../constants/ActionTypes"

const initState = {
    params : null,
    ORDER_DETAIL : null,
    LOGISTIC_INFO : null,
    IS_SPLIT_PACKAGE : null,
    AD_TEXT: null
}

export default function ( state = initState, action = {} ){

    switch( action.type ){

        //订单详情接口数据
        case LOCATIONS.ORDER_DETAIL:
            return Object.assign({},state,{
                ORDER_DETAIL:action.ORDER_DETAIL
            });
        break;

        //存入的orderId
        case LOCATIONS.LOCATIONS_PARAMS:
            return Object.assign({},state,{
                params:action.LOCATIONS_PARAMS
            })
        break;

        //调取物流信息接口数据
        case LOCATIONS.LOGISTIC_INFO:
            return Object.assign({},state,{
                LOGISTIC_INFO : action.LOGISTIC_INFO
            })
        break;

        //是否为拆单
        case LOCATIONS.IS_SPLIT_PACKAGE:
            return Object.assign({},state,{
                IS_SPLIT_PACKAGE : action.IS_SPLIT_PACKAGE
            })
        break;

        // 广告位信息
        case LOCATIONS.AD_TEXT:
            return Object.assign({},state,{
                AD_TEXT : action.AD_TEXT
            })
        break;

        default:
            return state;break;
    }
}




// WEBPACK FOOTER //
// ./common/reducers/locations.js